import { useEffect, useState } from "react";

/**
 * Defers rendering until the browser is idle (or a timeout), so first paint
 * is not blocked by non-critical UI such as the analytics consent banner.
 */
export function useIdleMount(timeoutMs = 2_000): boolean {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const markMounted = () => setMounted(true);

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(markMounted, { timeout: timeoutMs });
      return () => window.cancelIdleCallback(idleId);
    }

    const timerId = setTimeout(markMounted, 0);
    return () => clearTimeout(timerId);
  }, [timeoutMs]);

  return mounted;
}
